// import $ from 'jquery'
import _ from 'underscore';
import Backbone from 'backbone';
import { state } from '../state-manager/state-model';
import { addComma, toText } from '../utils/number-format';
export var PmangBonusModel = Backbone.Model.extend({
  url: 'pmbonus',

  defaults: {
    userName: '',
    startMonth: '',
    totalPoint: 0,
    rewards: [],
    history: [],
    chosenRewardId: null,
    rewardId: 0,
    rewardPoint: 0
  },

  initialize: function () {
    _.bindAll(this, 'getItemById');
    this.state = state;
  },

  parse: function (res) {
    var data = res.result;

    // 내 피망 보너스
    var totalPoint = addComma(data.totalPoint);

    // 혜택 리스트
    var rewards = _.map(data.rewards, function (item) {
      // 1. 2021년 6월 추가. 보상이 머니가 아니라 특별한 혜택일 경우
      if (item.rewardText) {
        var validDate = item.validDate
          ? item.validDate.replace(/(\d\d\d\d)(\d\d)(\d\d)/, '$1/$2/$3')
          : '';

        // 현재 혜택 사용중일 경우
        var periodWarning = item.using
          ? '(' + validDate + ' 까지 적용중)'
          : '(유효기간 : ' + validDate + ' 까지)';

        return _.extend(item, {
          onlyMoney: false,
          pointText: addComma(item.point),
          reward: item.rewardText,
          status: item.using ? 'disabled' : 'enabled', // 활성화, 비활성화
          periodWarning: periodWarning
        });
      }

      // 2. 보상이 머니일 경우
      return _.extend(item, {
        onlyMoney: true,
        pointText: addComma(item.point),
        reward: toText(item.reward, { comma: true }),
        status: data.totalPoint < item.point ? 'disabled' : 'enabled'
      });
    });

    // 사용내역
    var history = _.map(data.history, function (item) {
      var consumed = addComma(item.consumed);
      return _.extend(item, {
        regDate: item.regDate.replace(/(\d\d\d\d)(\d\d)/, '$1년 $2월'),
        saved: addComma(item.saved),
        // 차감 보너스 0 보다 크면 앞에 '-' 추가.
        consumed: item.consumed > 0 ? '-' + consumed : consumed
      });
    });

    return _.extend(data, {
      // 유저명
      userName: this.state.get('nickname'),
      // 사용가능한 보너스 적립 시작 년월
      startMonth: data.startMonth,
      totalPoint: totalPoint,
      rewards: rewards,
      history: history
    });
  },

  getItemById: function (id) {
    var items = this.get('rewards');
    return _.find(items, function (el) {
      return el.id === id;
    });
  }
});
